export default "__VITE_ASSET__BgZwB89F__"